import { useMemo } from 'react';
import { useConfig } from 'shared/config/ConfigContext';
import type { HotelResponse } from '@/interfaces';

const DEFAULT_IMAGE = 'https://www.finn.no/assets/finn-logo-large.png';

export const useHotelSeo = (hotel: HotelResponse | null) => {
    const { imgPath, contextPathPP } = useConfig();

    return useMemo(
        () =>
            hotel?.id
                ? {
                      title: `Pakkereiser til ${hotel.name}`,
                      description: `${hotel.name}, ${hotel.destination}, ${hotel.region}, ${hotel.country}`,
                      url: `https://www.finn.no${contextPathPP}/hotell?hotellId=${hotel.id}`,
                      image: `${imgPath}1280w${hotel.imagePaths[0]}`,
                  }
                : {
                      title: 'Dette hotellet finnes ikke :(',
                      description: 'Vi kunne dessverre ikke finne dette hotellet',
                      url: undefined,
                      image: DEFAULT_IMAGE,
                  },
        [hotel, imgPath, contextPathPP],
    );
};
